import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();
export const pushToHistory = (url: string) => history.push(url);
